export default __webpack_public_path__ + "images/bd1a581147e41c40f9eee1649b1bb1a6-craft.jpg";